import React from "react";
import i18n from "../i18n";
import {logEvent, userEvents} from "../utils/log";
import FileChooseButton from "./FileChooseButton";
import uploadHandler from "../utils/upload.handler";
import processingManager from "../photolab/ProcessingManager";
import Processing from "../photolab/Processing";
import {webviewAnalyticsEvent} from "../utils/webview";

const LOADING_TEXT_INTERVAL = 3000;

export default class Loading extends React.Component {

  constructor(props) {
    super(props);

    this.texts = [
      "processing_text_1",
      "processing_text_2",
      "processing_text_3",
      "processing_text_4",
    ];

    this.state = {
      imageIsLoaded: false,
      //textIndex: Math.floor(Math.random() * (this.texts.length - 1)),
      textIndex: 0,
      showUploadForm: true,
    };

    this.updateTextIndexTimer = null;

    this.image = new Image();
    this.image.onload = () => this.setState({imageIsLoaded: true});
  }

  componentDidMount() {
    if (this.props.image) {
      this.image.src = this.props.image;
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.image !== this.props.image) {
      this.setState({imageIsLoaded: false}, () => {
        if (this.props.image) {
          this.image.src = this.props.image;
        }
      });
    }

    if (prevProps.isHidden !== this.props.isHidden) {
      if (this.props.isHidden) {
        clearInterval(this.updateTextIndexTimer);
        this.updateTextIndex();
        this.setState({showUploadForm: true});
      } else {
        this.updateTextIndexTimer = setInterval(this.updateTextIndex, LOADING_TEXT_INTERVAL);
      }
    }
  }

  componentWillUnmount() {
    this.image.onload = () => {};
    clearInterval(this.updateTextIndexTimer);
  }

  updateTextIndex = () => {
    if (this.state.textIndex === this.texts.length - 1) {
      this.setState({textIndex: 0});
    } else {
      this.setState({textIndex: this.state.textIndex + 1});
    }
  }

  handleHideUploadForm = () => {
    logEvent(userEvents.SKIP_BUTTON_CLICK, {page: "processing"});

    webviewAnalyticsEvent("skip_tapped",
      processingManager.processing && processingManager.processing.getExtra(Processing.EXTRA_TEXT),
      "",
      "",
      "",
      "generate"
    );

    this.setState({
      showUploadForm: false,
    });
  }

  handleStartFileChoosing = () => {
    const processing = processingManager.processing;

    webviewAnalyticsEvent("choose_photo_tapped",
      processing && processing.getExtra(Processing.EXTRA_TEXT),
      "",
      "",
      "",
      "generate",
    );

    this.setState({
      showUploadForm: false,
    });
  }

  handleFileSelected = (file) => {
    logEvent(userEvents.PHOTO_SELECT, {page: "processing"});

    const processing = processingManager.processing;

    webviewAnalyticsEvent("photo_selected",
      processing && processing.getExtra(Processing.EXTRA_TEXT),
      "",
      "avatar",
      "",
      "generate",
    );

    uploadHandler(file)
      .then((result) => {
        logEvent(userEvents.PHOTO_UPLOADED, {
          file_id: result.id,
          file_url: result.url,
          uploaded_at: Date.now(),
        });

        if (processingManager.processing) {
          processingManager.processing.setExtra(Processing.EXTRA_PROCESSING_FILE, result);
          processingManager.update();
        }
      })
      .catch((error) => {
        /* ignore */
      });
  }

  render() {
    const classNames = ["loader"];
    this.props.className && classNames.push(this.props.className);

    return <main className={classNames.join(" ")} hidden={this.props.isHidden}>
      <div className="main">
        <div className="spinner-container">
          <div className="triple-spinner">
            <div className="triple-spinner2" />
            <div className="dot-center" />
          </div>

          {!this.state.imageIsLoaded && <svg viewBox="0 0 101 100" fill="none">
            <path d="M80.565 80.876a4.269 4.269 0 0 1 0-3.241c.213-.5.516-.958.893-1.335l.024-.032c.213-.213.459-.418.72-.573.14-.09.287-.172.45-.246V68.72h-6.966a6.826 6.826 0 0 1-1.931 3.823 7.01 7.01 0 0 1-4.97 2.055h-4.198V92.95h12.32c.065-.107.13-.213.204-.32a4.174 4.174 0 0 1 1.866-1.506 4.269 4.269 0 0 1 3.242 0c.524.213.982.532 1.375.917.385.385.704.851.917 1.375a4.27 4.27 0 0 1 0 3.242c-.213.524-.532.99-.917 1.375a4.177 4.177 0 0 1-1.375.917 4.27 4.27 0 0 1-1.621.319 4.159 4.159 0 0 1-1.588-.311l-.033-.008a4.262 4.262 0 0 1-1.375-.917 4.616 4.616 0 0 1-.63-.802 4.369 4.369 0 0 1-.262-.516H62.704c-.524 0-.99-.213-1.335-.557a1.881 1.881 0 0 1-.564-1.342v-20.22h-9.169v16.65c.14.075.279.148.418.238.254.156.491.352.696.557.393.393.704.851.916 1.375.205.5.32 1.048.32 1.62a4.16 4.16 0 0 1-.311 1.589l-.008.033a4.26 4.26 0 0 1-.917 1.375 4.176 4.176 0 0 1-1.376.917 4.27 4.27 0 0 1-3.241 0 4.176 4.176 0 0 1-1.375-.917 4.176 4.176 0 0 1-.917-1.375 4.27 4.27 0 0 1-.32-1.621c0-.557.107-1.089.312-1.588l.008-.033c.213-.524.532-.982.917-1.375.204-.205.425-.385.67-.54l.034-.025c.13-.074.27-.147.409-.221V74.598H35.64v8.628c0 .524-.213.99-.556 1.334-.344.344-.81.557-1.335.557h-8.677c-.065.13-.139.253-.22.384-.148.221-.32.434-.516.63l-.033.033a4.174 4.174 0 0 1-1.375.917c-.5.205-1.048.32-1.621.32a4.159 4.159 0 0 1-1.588-.312l-.033-.008a4.26 4.26 0 0 1-1.375-.917 4.174 4.174 0 0 1-.917-1.375 4.269 4.269 0 0 1 0-3.241c.213-.524.532-.99.917-1.376a4.585 4.585 0 0 1 1.4-.908 4.27 4.27 0 0 1 3.241 0c.5.213.958.516 1.335.9l.032.025c.213.213.418.458.573.72.082.14.172.287.246.45h6.729v-6.917a7.038 7.038 0 0 1-3.455-1.89c-1.236-1.237-1.997-2.923-1.997-4.773v-4.494H6.328v12.32c.106.065.213.13.319.204.213.148.401.311.59.492.384.384.703.85.916 1.375a4.27 4.27 0 0 1 0 3.241 4.262 4.262 0 0 1-.917 1.376 4.174 4.174 0 0 1-1.375.916 4.269 4.269 0 0 1-3.242 0 4.174 4.174 0 0 1-1.375-.916 4.175 4.175 0 0 1-.917-1.376A4.266 4.266 0 0 1 0 79.28c0-.556.106-1.089.311-1.588l.008-.033c.213-.524.532-.982.917-1.375.237-.237.516-.45.802-.63.156-.099.344-.188.516-.262V61.394c0-.524.213-.99.557-1.334a1.881 1.881 0 0 1 1.342-.565h21.963v-9.168H8.03c-.073.139-.147.278-.237.417a3.85 3.85 0 0 1-.557.696 4.134 4.134 0 0 1-1.375.917 4.27 4.27 0 0 1-1.62.319 4.16 4.16 0 0 1-1.589-.311l-.033-.008a4.262 4.262 0 0 1-1.375-.917 4.176 4.176 0 0 1-.917-1.375 4.27 4.27 0 0 1 0-3.242c.213-.524.533-.99.917-1.375a4.176 4.176 0 0 1 1.375-.917 4.165 4.165 0 0 1 1.63-.327 4.16 4.16 0 0 1 1.588.31l.032.009a4.264 4.264 0 0 1 1.924 1.588l.024.033c.074.13.148.27.222.409h18.377V35.167c0-.279.016-.557.049-.836H16.052c-.523 0-.99-.212-1.334-.556a1.874 1.874 0 0 1-.556-1.334v-8.677a4.66 4.66 0 0 1-.385-.221 4.141 4.141 0 0 1-.63-.516l-.033-.033a4.176 4.176 0 0 1-.917-1.375 4.27 4.27 0 0 1-.32-1.62c0-.558.107-1.09.312-1.589l.008-.033c.213-.524.532-.982.917-1.375a4.177 4.177 0 0 1 1.375-.917 4.27 4.27 0 0 1 3.242 0c.523.213.99.532 1.375.917.376.401.696.876.908 1.4a4.269 4.269 0 0 1 0 3.241 4.24 4.24 0 0 1-.892 1.335l-.024.032a3.577 3.577 0 0 1-.729.573c-.14.082-.286.172-.45.246v6.729h10.273v.049c.066-.074.14-.147.205-.213a7.01 7.01 0 0 1 4.969-2.054h3.937V6.328H25c-.066.106-.131.213-.205.319a4.175 4.175 0 0 1-1.866 1.506 4.27 4.27 0 0 1-3.242 0 4.262 4.262 0 0 1-1.375-.917 4.174 4.174 0 0 1-.917-1.375 4.31 4.31 0 0 1-.32-1.629c0-.565.115-1.105.32-1.62.213-.525.532-.991.917-1.376A4.175 4.175 0 0 1 19.687.32 4.27 4.27 0 0 1 21.307 0a4.16 4.16 0 0 1 1.589.311l.033.008c.524.213.982.532 1.375.917.237.237.45.516.63.802.098.156.188.344.27.516h13.99c.524 0 .99.213 1.334.557.352.352.565.818.565 1.342V28.34h9.168V8.03c-.139-.073-.278-.147-.417-.237a3.851 3.851 0 0 1-.696-.557 4.136 4.136 0 0 1-.917-1.375 4.27 4.27 0 0 1-.32-1.62c0-.557.107-1.09.312-1.589l.008-.033c.213-.523.532-.982.917-1.375a4.177 4.177 0 0 1 1.375-.917 4.27 4.27 0 0 1 3.242 0c.524.213.99.533 1.375.917.385.385.704.852.917 1.375.204.5.32 1.048.32 1.621a4.16 4.16 0 0 1-.312 1.588l-.008.033a4.262 4.262 0 0 1-1.588 1.924l-.033.024c-.131.074-.27.148-.41.221v20.301h12.222V16.052c0-.523.213-.99.557-1.334.344-.344.81-.556 1.334-.556h8.685c.066-.131.14-.254.221-.385.148-.221.32-.434.516-.63l.033-.033a4.178 4.178 0 0 1 1.375-.917 4.27 4.27 0 0 1 1.62-.32c.558 0 1.09.107 1.589.312l.033.008c.523.213.982.532 1.375.917.385.384.704.851.917 1.375a4.27 4.27 0 0 1 0 3.242c-.213.523-.532.99-.917 1.375-.41.376-.876.696-1.4.908a4.269 4.269 0 0 1-3.242 0 4.241 4.241 0 0 1-1.334-.892l-.033-.024a3.763 3.763 0 0 1-.573-.72 3.353 3.353 0 0 1-.245-.451H70.03v10.51a6.992 6.992 0 0 1 3.733 1.949c1.236 1.236 1.997 2.922 1.997 4.772v.843h18.5v-12.32c-.106-.065-.213-.13-.319-.204a4.197 4.197 0 0 1-.581-.491 4.175 4.175 0 0 1-.917-1.375 4.269 4.269 0 0 1 0-3.242c.213-.524.532-.982.917-1.375a4.176 4.176 0 0 1 1.375-.917 4.27 4.27 0 0 1 3.242 0c.523.213.99.532 1.375.917s.704.851.917 1.375c.204.5.319 1.048.319 1.62 0 .558-.106 1.09-.311 1.589l-.008.033a4.266 4.266 0 0 1-.917 1.375c-.237.237-.516.45-.802.63a6.167 6.167 0 0 1-.516.27v13.99c0 .524-.213.99-.557 1.334a1.881 1.881 0 0 1-1.342.565H75.76v9.168h16.798a4.242 4.242 0 0 1 .794-1.113 4.134 4.134 0 0 1 1.375-.917 4.27 4.27 0 0 1 1.62-.319 4.16 4.16 0 0 1 1.589.311l.032.008c.524.213.983.532 1.376.917.384.385.704.851.916 1.375a4.264 4.264 0 0 1 0 3.242c-.212.524-.532.99-.916 1.375a4.177 4.177 0 0 1-1.376.917 4.27 4.27 0 0 1-1.62.32 4.16 4.16 0 0 1-1.588-.312l-.033-.008a4.262 4.262 0 0 1-1.924-1.588l-.024-.033c-.074-.13-.148-.27-.221-.41H75.76V64.93h8.775c.524 0 .99.213 1.335.557.343.344.556.81.556 1.334v8.685c.131.066.254.14.385.23.221.147.434.319.63.515l.033.033c.385.385.704.851.917 1.375.205.5.32 1.048.32 1.621 0 .557-.107 1.089-.312 1.588l-.008.033a4.262 4.262 0 0 1-.917 1.375 4.177 4.177 0 0 1-1.375.917 4.27 4.27 0 0 1-3.242 0 4.176 4.176 0 0 1-1.375-.917 4.608 4.608 0 0 1-.917-1.4zM43.786 42.681H58.39c1.138 0 2.063.925 2.063 2.063v13.45a2.065 2.065 0 0 1-2.063 2.062H43.786a2.065 2.065 0 0 1-2.063-2.063v-13.45c0-1.137.925-2.062 2.063-2.062zm25.008-10.69h-35.42a2.94 2.94 0 0 0-2.096.883 3.228 3.228 0 0 0-.941 2.292v32.605c0 .9.36 1.71.941 2.292a2.953 2.953 0 0 0 2.096.884h35.42a2.94 2.94 0 0 0 2.096-.884 3.228 3.228 0 0 0 .941-2.292V35.166c0-.9-.36-1.71-.941-2.292a2.94 2.94 0 0 0-2.096-.884z" fill="#B7FFCF"/>
          </svg>}

          {this.state.imageIsLoaded && <img
            className="avatar-image"
            src={this.props.image}
            alt="" />}
        </div>
        <div className="loader-text-container" hidden={this.props.hideText}>
          <p className="loader-tip" hidden dangerouslySetInnerHTML={{__html: i18n.t("processing_tip", {item: this.state.textIndex + 1, total: this.texts.length})}} />
          <p dangerouslySetInnerHTML={{__html: i18n.t(this.texts[this.state.textIndex]) || ""}} />
        </div>
      </div>
      <div className="upload">
        <div className="container">
          <div className="loader-view-container">
            <div className="loader-view">
              <span className="item-loader first-item-loader" />
              <span className="item-loader second-item-loader" />
              <span className="item-loader third-item-loader" />
            </div>
            <p hidden={this.props.hideText}
               dangerouslySetInnerHTML={{__html: i18n.t(this.texts[this.state.textIndex]) || ""}}
            />
          </div>
          <div hidden={!this.state.showUploadForm}>
            <div className="loader-container">
              <p>{i18n.t("processing_upload_text")}</p>
            </div>
            <div className="btns-container">
              <FileChooseButton
                onClick={this.handleStartFileChoosing}
                onFileSelected={this.handleFileSelected}
                children={i18n.t("btn_choose_photo")}/>
              <button
                className="btn-grey"
                onClick={this.handleHideUploadForm}
                children={i18n.t("btn_skip")} />
            </div>
          </div>
        </div>
      </div>
    </main>;
  }
}
